import { ICurrencyState } from "../model"

export function getDefaultCurrencyState(): ICurrencyState {
  return {
    currencies: []
  }
}
